<div class="position">
    <div class="card-404 form-wrap icon-size-3 centered-vertically-column-container column-gap-1 height-100pcnt">
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24 10.0001V18.4001M24 26.8001V26.5895M30.0869 34.7131L24 46.4001L18.4 34.7131H7.19997C4.10718 34.7131 1.59998 32.2059 1.59998 29.1131V7.2001C1.59998 4.10731 4.10718 1.6001 7.19997 1.6001H40.8C43.8928 1.6001 46.4 4.1073 46.4 7.2001V29.1131C46.4 32.2059 43.8928 34.7131 40.8 34.7131H30.0869Z" stroke="#4E585C" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg> 
            <div class="whitespace-0p75"></div>         
        <span class="centered-column-container opacity0p64 column-gap-0p5">
            <span class="text-center title-2 bold600">The page you are looking for <br> does not exist...</span>
        </span>
        <div class="whitespace-0p5"></div>
        <button class="servc-button button-main standard-size" (click)="goToLogin()">
            Back to login
        </button>
    </div>
</div>